import Vue from 'vue'
Vue.filter("filterDate",(date,type)=>{
    Date.prototype.format = function (fmt) { //author: meizz
        var o = {
            "M+": this.getMonth() + 1, //月份
            "d+": this.getDate(), //日
            "h+": this.getHours(), //小时
            "m+": this.getMinutes(), //分
            "s+": this.getSeconds(), //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }
    let now=new Date(parseInt(date)*1000).format(type);
    return now;
})

Vue.filter('levelFilter',level=>{
    switch (level){
        case '1':return 'A';
        case '2':return 'B';
        case '3':return 'C';
        case '4':return 'D';
        case '5':return 'S';
    }
});
Vue.filter('orderStatusFilter',status=>{
  switch (status) {
    case '0':return '未成交';
    case '1':return '部分成交';
    case '2':return '已完成';
    case '-1':return '已撤销';
  }
})

Vue.filter('levelFilter',level=>{
  switch (level) {
    case '1':return '普通用户';
    case '2':return '明星经济商';
    case '3':return '股东经济商';
  }
})

//电话号码格式化
Vue.filter("phone",(n)=>{
  let str = n.toString()
  let phone = str.replace(/([0-9]{3})([0-9]{4})([0-9]{4})/g,"$1****$3")
  return phone
})



// WEBPACK FOOTER //
// ./src/filters/filters.js